import { getUser } from '~/services/user/info';

function getPermissions() {
    return getUser().permissions || [];
}

function setPermissions(permissions) {
    getUser().permissions = permissions;
}

function hasAccess(permission) {
    return getPermissions().includes(permission);
}

function hasAccessToAny(permissions) {
    if (permissions) {
        const userPermissions = getPermissions();
        let accessCount = 0;

        permissions.forEach((permission) => {
            if (userPermissions.includes(permission)) {
                accessCount++;
            }
        });

        return accessCount > 0;
    }

    return false;
}

function hasAccessToAll(permissions) {
    return permissions.every(permission => hasAccess(permission));
}

export { hasAccess, hasAccessToAny, hasAccessToAll, getPermissions, setPermissions }
